module.exports = __webpack_public_path__ + "img/Arcane_Image_2.e22d24da.jpeg";